const trustItems = [
  { icon: 'ri-map-pin-2-line', label: 'Locally Owned & Operated', sub: 'Maryland-based since 2009' },
  { icon: 'ri-shield-check-line', label: 'Fully Licensed & Insured', sub: 'State of Maryland certified' },
  { icon: 'ri-star-fill', label: '5-Star Rated', sub: '500+ verified reviews' },
  { icon: 'ri-home-heart-line', label: 'Residential Specialists', sub: 'Exclusively homeowners' },
  { icon: 'ri-road-map-line', label: 'Serving All of Maryland', sub: 'Baltimore to DC suburbs' },
];

export default function TrustBar() {
  return (
    <section className="bg-white border-b border-sand-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-stretch divide-x divide-sand-dark">
          {trustItems.map((item) => (
            <div key={item.label} className="flex-1 min-w-44 flex items-center gap-3.5 px-7 py-6 group">
              <div className="w-11 h-11 flex items-center justify-center bg-gold/10 rounded-xl flex-shrink-0 group-hover:bg-gold/20 transition-colors">
                <i className={`${item.icon} text-gold text-xl`} />
              </div>
              <div>
                <div className="font-sans text-sm font-bold text-walnut leading-tight">{item.label}</div>
                <div className="font-sans text-xs text-charcoal/50 mt-0.5">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
